
module.exports = () => JSON.parse(localStorage.getItem('preferences'))